import ISubmitOrderDTO from "@models/DTO/ISubmitOrderDTO";
import IOrder from "@models/IOrder";
import IOwRadioSelectOption from "@models/IOwRadioSelectOption";
import OwRadioSelect from "@components/shared/OwRadioSelect/OwRadioSelect";
import React, { useState } from "react";
import "./OrderEntryBackorderSelectionModal.scss";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import OwTranslate from "@components/shared/OwTranslate/OwTranslate";
import OwButton from "@components/shared/OwButton/OwButton";
import { useAppContextNonNull } from "@contexts/AppContext";
import BackorderBehaviorEnum from "@models/BackorderBehaviorEnum";

type Props = {
    orderModel: IOrder;
    cancelFn: () => void;
    tempSubmitOrderPayload: ISubmitOrderDTO;
    submitOrderFn: (payload: ISubmitOrderDTO) => void;
};

export const OrderEntryBackorderSelectionModal = (props: Props) => {
    const { supplierModel } = useAppContextNonNull();

    const processPayload = () => {
        const payload = props.tempSubmitOrderPayload;

        if (supplierModel.default_backorder_behavior) {
            switch (supplierModel.default_backorder_behavior) {
                case BackorderBehaviorEnum.PARTIAL_FILL:
                    payload.allowPartialFulfillment = true;
                    break;
                case BackorderBehaviorEnum.FULL:
                    payload.allowPartialFulfillment = false;
                    break;
                case BackorderBehaviorEnum.MANUAL:
                    payload.allowPartialFulfillment = undefined;
                    break;
            }
        }

        return payload;
    };

    const [submitOrderPayload, setSubmitOrderPayload] = useState<ISubmitOrderDTO>(() => {
        const payload = processPayload();
        if (payload.allowPartialFulfillment !== true) {
            payload.allowPartialFulfillment = false;
        }
        return payload;
    });
    const [selectedOption, setSelectedOption] = useState<string>(
        props.tempSubmitOrderPayload.allowPartialFulfillment ? "partial" : "backorder_all"
    );

    const backorderOptions: IOwRadioSelectOption[] = [
        {
            value: "partial",
            label: "partial_fill_and_backorder_remaining",
        },
        {
            value: "backorder_all",
            label: "backorder_all",
        },
        {
            value: "manual",
            label: "manual_backorder",
        },
    ];

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSelectedOption(value);

        const isPartialFill = value === "partial";

        const updatedPayload: ISubmitOrderDTO = {
            ...submitOrderPayload,
            allowPartialFulfillment: isPartialFill,
        };

        if (value === "manual") {
            updatedPayload.allowPartialFulfillment = undefined;
        }

        console.log("updatedPayload", updatedPayload);

        setSubmitOrderPayload(updatedPayload);
    };

    const handleSubmit = () => {
        props.submitOrderFn(submitOrderPayload);
    };

    return (
        <div className={"OrderEntryBackorderSelectionModal"}>
            <div className="modal-header">
                <OwTitle title={"backorder_selection"} tag={"h5"} />
            </div>
            <div className="modal-body">
                <p>
                    <OwTranslate
                        id={"backorder_selection_description"}
                        defaultMessage={"Because this order can't be filled in full, please select how you would like to handle this order"}
                    />
                </p>
                <OwRadioSelect
                    options={backorderOptions}
                    name="backorderSelection"
                    fn={handleRadioChange}
                    value={selectedOption}
                    translateUseLabel={true}
                />
            </div>
            <div className="modal-footer">
                <OwButton title={"cancel"} fn={props.cancelFn} className={"me-2 btn-secondary"} />
                <OwButton title={"submit_order"} fn={handleSubmit} />
            </div>
        </div>
    );
};
